import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, delay } from 'rxjs/operators';
import { FidPickerService } from '../services/fid-picker.service';
import { loadFidPicker, loadFidPickerSuccess, loadFidPickerFailure } from './fid-picker.actions';

@Injectable()
export class FidPickerEffects {
  constructor(
    private actions$: Actions,
    private fidPickerService: FidPickerService
  ) {}

  // Load FID Picker Effect
  loadFidPicker$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFidPicker), // Listen for loadFidPicker action
      switchMap(() =>
        // Call service to get data
        this.fidPickerService.getFidPickerItems().pipe(
          delay(1000), // Simulate network delay
          map(items => 
            // Dispatch success action with data
            loadFidPickerSuccess({ items })
          ),
          catchError(error => 
            // Dispatch failure action with error
            of(loadFidPickerFailure({ 
              error: error.message || 'Failed to load FID picker items' 
            }))
          )
        )
      )
    )
  );
} 